import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Password } from 'src/app/interfaces/password';
import { RestablecerPassword } from 'src/app/interfaces/restablecerPassword';
import { RestablecerPasswordService } from 'src/app/services/restablecerPassword/restablecerPassword.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  restablecerPassword: RestablecerPassword;
  rol: string;
  url: string;

  formToken: FormGroup;
  formPass: FormGroup;
  mensajeExito: string;
  mensajeError: string;
  mensajeErrorToken: string;
  mensajeExitoToken: string;
  tokenVerificado: boolean;
  mostrarMensaje:boolean;
  showNuevaPass: boolean = false;
  showConfirmPass: boolean = false;

  constructor(private formBuilder: FormBuilder, private restablecer: RestablecerPasswordService,
        private router: Router, private scroller: ViewportScroller, private title: Title, private meta: Meta) {
            this.agregarMetaData();
        this.url = this.router.url;
        this.mostrarMensaje = false;
   }

  ngOnInit() {
    this.formPass = this.formBuilder.group({
        passNueva: [null, [Validators.required, Validators.minLength(8)]],
        passConfim: [null, [Validators.required, Validators.minLength(8)]]
    });
    this.formToken = this.formBuilder.group({
        token: [null, Validators.required]
    })
  }

  private agregarMetaData(): void {
    this.title.setTitle('Restablecer Contraseña');
    this.meta.updateTag({name: "description", content: "Ingresa tu código para poder restablecer tu contraseña."});
    this.meta.updateTag({name: "keywords", content: "constraseña, password, restablecer, cuenta, candidato, empresa, empleos"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Restablecer Contraseña"});
    this.meta.updateTag({property: "og:description", content: "Ingresa tu código para poder restablecer tu contraseña."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Restablecer Contraseña"});
    this.meta.updateTag({name: "twitter:description", content:"Ingresa tu código para poder restablecer tu contraseña."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerUsuarioToken(token: string, rol: string){
    try {
      const response = await this.restablecer.obtenerTokenActivo(token, rol);
      this.restablecerPassword = response.data;
      this.tokenVerificado = true;
      this.mensajeExitoToken = "Porfavor ingrese su nueva contraseña";
      setTimeout(() => {
          this.mensajeExitoToken = "" as string;
      }, 2000);
    } catch (error) {
        console.error("Error al obtener Token Activo del usuario", error);
        this.mensajeErrorToken = error.error.message
        setTimeout(() => {
            this.mensajeErrorToken = "" as string;
          }, 3000);
    }
  }

  verificarToken(){
    this.rol = this.url.slice(18);
    const token: string = this.formToken.value.token.trim();
    this.obtenerUsuarioToken(token, this.rol);
  }

  actualizarContrasenia(){
    this.mostrarMensaje = true;
    if (this.formPass.get('passNueva').value !== this.formPass.get('passConfim').value) {
        this.mensajeError = 'Las contraseñas no coinciden.';
        setTimeout(() => {
            this.mensajeError = "" as string;
          }, 4000);
        return;
    }
    if(this.formPass.valid){
      const password: Password = {
        idUsuario: this.restablecerPassword.idUsuario,
        nuevaPass: this.formPass.get('passNueva').value,
        confirmPass: this.formPass.get('passConfim').value,
        rol: this.restablecerPassword.rol
      };
      this.mostrarMensaje = false;
      this.restablecer.restablecerPassword(password)
      .pipe(catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.mensajeError = mensajeError;
        setTimeout(() => {
          this.mensajeError = "" as string;
        }, 4000);
        return throwError(mensajeError);
      }))
      .subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mensajeExito = 'Éxito se ha actualizado su contraseña.';
          this.router.navigate([`/acceder`])
          setTimeout(() => {
            this.mensajeExito = "" as string;
          }, 4000);
        } else {
          this.mensajeError = result.messageError;
          console.error('Error al actualizar la contraseña', result.messageError);
        }
      });
    }
    setTimeout(() => {
        this.mostrarMensaje = false;
      }, 3000);
  }
}
